import './component.scss'

var $ = require('jquery')

$(() => {
  const ga_send_url = $('#request-url').val()
  const ga_label = $('.ga-label')[0].value
  const pc_device_name = $('.pc-device-name')[0].value

  function sendGaForPc () {
    ga('send', 'event', 'click', ga_send_url, pc_device_name + '_' + ga_label)
  }

  $('.pc-ga-send-side-banner').on('click', sendGaForPc)
})
